var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsiGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H18C19.6569 0 21 1.34315 21 3V12C21 13.6569 19.6569 15 18 15H3C1.34315 15 0 13.6569 0 12V3ZM14.8636 11.52C13.7228 11.52 12.5924 11.138 11.6983 10.3538L12.6335 9.25797C13.3118 9.81091 14.0209 10.1628 14.8944 10.1628C15.5932 10.1628 16.0249 9.87123 16.0249 9.41882V9.39872C16.0249 8.96642 15.7577 8.74524 14.4833 8.43358C12.9521 8.0616 11.9963 7.63936 11.9963 6.20171V6.1816C11.9963 4.87465 13.0857 4 14.6067 4C15.696 4 16.6107 4.33176 17.3711 4.92492L16.5387 6.09112C15.881 5.62866 15.2233 5.35722 14.5758 5.35722C13.9181 5.35722 13.5687 5.66888 13.5687 6.04086V6.06096C13.5687 6.56364 13.8976 6.73455 15.213 7.06631C16.7443 7.44834 17.5972 7.99123 17.5972 9.24791V9.26802C17.5972 10.7057 16.4668 11.52 14.8636 11.52ZM3.83334 4.10051V11.4194H6.72115C9.07456 11.4194 10.6983 9.82094 10.6983 7.75997V7.73987C10.6983 5.67891 9.07456 4.10051 6.72115 4.10051H3.83334ZM5.40571 5.49794H6.72115C8.10853 5.49794 9.04373 6.43292 9.04373 7.75997V7.78008C9.04373 9.10714 8.10853 10.022 6.72115 10.022H5.40571V5.49794Z",
    fill: "#70777A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsiGreyIcon);
export default __webpack_public_path__ + "static/media/DSIGreyIcon.bd73b40593462ccd7382d48472b3f47a.svg";
export { ForwardRef as ReactComponent };